
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import rules from "@/services/helpers/validation-rules";
import { mask } from "vue-the-mask";

export default Vue.extend({
  name: "Create",

  directives: { mask },

  data: () => ({
    rules,
    model: {} as any,
    errorMessages: {} as { [value: string]: Array<string> },
    selects: {
      cities: [] as Array<SelectComponentInterface>
    }
  }),

  async beforeRouteEnter(to, from, next) {
    try {
      const cities = await API.cities().getList();

      next(vm => {
        vm.selects.cities = cities;

        vm.$nextTick(() => {
          vm.fullLoaded = true;
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as Vue).validate()) {
          await this.$API.branches().create({ ...this.model });
          await this.$router.push("/branches");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;

          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    }
  }
});
